import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage, makeDataDangerous} from 'nutshell-core/utils/graphql-errors';

import type {
    GetInvoiceTemplate as GetInvoiceTemplateQuery,
    GetInvoiceTemplate_invoiceTemplate as Invoice,
} from 'nutshell-graphql-types';

import GET_INVOICE_TEMPLATE from '../queries/get-invoice-template.graphql';

export const useGetInvoiceTemplate = (): {
    invoiceTemplate: Invoice;
    isLoading: boolean;
    error: string | null | undefined;
    refetch: () => Promise<any>;
} => {
    const {loading, data, error, refetch} = useQuery<GetInvoiceTemplateQuery, Record<any, any>>(
        GET_INVOICE_TEMPLATE,
        {}
    );

    const {invoiceTemplate} = makeDataDangerous(data);

    return {
        invoiceTemplate,
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
        refetch,
    };
};
